import { useEffect, useState } from 'react';
import { ExtraTableResize } from '../../extraTableResize';
import TableComponent from '../../TableComponent';

interface IProps {
  dataCustomer: any[];
  rowIndex: number;
  changeRowIndex: (rowIndex: number) => void; // 行を選択する
}

const CustomerSearchTable: React.FC<IProps> = (props: IProps) => {
  const columnInit: any = [
    {
      title: '得意先名',
      dataIndex: 'nam',
      width: 250,
      ellipsis: true,
    },
    {
      title: '住所',
      dataIndex: 'adr',
      width: 350,
      ellipsis: true,
    },
    {
      title: '電話番号',
      dataIndex: 'tel',
      width: 150,
      ellipsis: true,
    },
    {
      title: 'FAX番号',
      dataIndex: 'fax',
      width: 150,
      ellipsis: true,
    },
    {
      title: '得意先CD',
      dataIndex: 'cd1',
      width: 100,
      ellipsis: true,
    },
    {
      title: '営業所CD',
      dataIndex: 'cd2',
      width: 100,
      ellipsis: true,
    },
  ];

  const [columns, changeColumns] = useState(columnInit);
  const [rIdx, changeRowIndex] = useState(-1);

  useEffect(() => {
    if (rIdx >= 0) {
      props.changeRowIndex(rIdx);
      changeRowIndex(-1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rIdx]);

  return (
    <>
      <ExtraTableResize>
        <TableComponent
          columns={columns}
          data={props.dataCustomer}
          minHeight="35vh"
          maxHeight="35vh"
          updateColumns={changeColumns}
          rowIndex={rIdx}
          changeRowIndex={changeRowIndex}
        />
      </ExtraTableResize>
    </>
  );
};
export default CustomerSearchTable;
